import api from '@/helpers/api';

import type { WorkerActivityResponse } from '@/components/following/types';

export interface FetchWorkerActivityParams {
	workerId: string;
	cursor?: string | null;
	limit?: number;
	signal?: AbortSignal;
}

export const fetchWorkerActivity = async ({
	workerId,
	cursor,
	limit = 20,
	signal,
}: FetchWorkerActivityParams): Promise<WorkerActivityResponse> => {
	const response = await api.request<WorkerActivityResponse>({
		url: `/workers/${workerId}/activity`,
		method: 'GET',
		params: {
			limit,
			...(cursor ? { cursor } : {}),
		},
		signal,
	});
	return response.data;
};

export default {
	fetchWorkerActivity,
};
